import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./fees.css";

import { useLocation } from "react-router-dom";
export default function FeeList() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [month, setMonth] = useState("");
  const [fees, setFees] = useState([]);
  const [search, setSearch] = useState("");

  // 🔧 EDIT STATE
  const [editingFee, setEditingFee] = useState(null);
  const [newAmount, setNewAmount] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const studentId = params.get("student_id");
  const monthFromUrl = params.get("month");
  const MONTHS = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const loadClasses = async () => {
    const res = await API.get("/school-admin/classes/", {
      headers: { "X-SCHOOL-ID": school.school.id }
    });
    setClasses(res.data.classes);
  };

  const loadSections = async (id) => {
    if (!id) return;
    const res = await API.get(`/school-admin/sections/${id}/`, {
      headers: { "X-SCHOOL-ID": school.school.id }
    });
    setSections(res.data.sections);
  };

  useEffect(() => {
    loadClasses();
  }, []);
  useEffect(() => {
    if (monthFromUrl) {
      setMonth(monthFromUrl);
    }
  }, [monthFromUrl]);
  const loadFees = async () => {
    if (!month) return;

    const res = await API.get(`/school-admin/fees/list/`, {
      params: {
        student_id: studentId || "",
        class_id: studentId ? "" : classId,
        section_id: studentId ? "" : sectionId,
        month,
      },
      headers: { "X-SCHOOL-ID": school.school.id }
    });

    setFees(res.data.fees);
  };

  useEffect(() => {
    loadFees();
  }, [classId, month, sectionId]);

  // ================= MARK PAID =================
  const markAsPaid = async (feeId) => {
    if (!window.confirm("Mark this fee as paid?")) return;

    await API.post(
      `/school-admin/fees/mark-paid/${feeId}/`,
      {},
      { headers: { "X-SCHOOL-ID": school.school.id } }
    );

    loadFees();
  };

  // ================= DELETE =================
  const deleteFee = async (feeId) => {
    if (!window.confirm("Delete this pending fee?")) return;

    await API.delete(`/school-admin/fees/delete/${feeId}/`, {
      headers: { "X-SCHOOL-ID": school.school.id }
    });

    loadFees();
  };

  // ================= EDIT =================
  const saveEdit = async () => {
    await API.put(
      `/school-admin/fees/update/${editingFee.id}/`,
      { amount: newAmount },
      { headers: { "X-SCHOOL-ID": school.school.id } }
    );

    setEditingFee(null);
    loadFees();
  };

  const filteredFees = fees.filter(f =>
    f.student_name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="fees-container">
      <h2>Fees List</h2>

      {/* FILTERS */}
   {!studentId && (
  <div className="filter-row">

    {/* CLASS */}
    <select
      value={classId}
      onChange={(e) => {
        setClassId(e.target.value);
        loadSections(e.target.value);
      }}
    >
      <option value="">Select Class</option>
      {classes.map((c) => (
        <option key={c.id} value={c.id}>
          {c.name}
        </option>
      ))}
    </select>

    {/* SECTION */}
    <select
      value={sectionId}
      onChange={(e) => setSectionId(e.target.value)}
      disabled={!classId}
    >
      <option value="">Select Section</option>
      {sections.map((s) => (
        <option key={s.id} value={s.id}>
          {s.name}
        </option>
      ))}
    </select>

    {/* MONTH */}
    <select
      value={month}
      onChange={(e) => setMonth(e.target.value)}
    >
      <option value="">Select Month</option>
      {MONTHS.map((m) => (
        <option key={m} value={m}>
          {m}
        </option>
      ))}
    </select>

    {/* SEARCH */}
    <input
      placeholder="Search student..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />

  </div>
)}

      {/* TABLE */}
      <table className="fees-table">
        <thead>
          <tr>
            <th>Student</th>
            <th>Class</th>
            <th>Section</th>
            <th>Month</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {filteredFees.map(f => (
            <tr key={f.id}>
              <td>{f.student_name}</td>
              <td>{f.class_name}</td>
              <td>{f.section_name}</td>
              <td>{f.month}</td>
              <td>₹{f.amount}</td>

              <td>
                {f.status === "paid"
                  ? <span className="paid-badge">Paid</span>
                  : <span className="pending-badge">Pending</span>}
              </td>

              <td className="action-col">
                {f.status === "pending" && (
                  <>
                    <button
                      className="edit-btn"
                      onClick={() => {
                        setEditingFee(f);
                        setNewAmount(f.amount);
                      }}
                    >
                      Edit
                    </button>

                    {/* <button
                      className="delete-btn"
                      onClick={() => deleteFee(f.id)}
                    >
                      Delete
                    </button> */}

                    <button
                      className="mark-paid-btn"
                      onClick={() => markAsPaid(f.id)}
                    >
                      Mark Paid
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ================= EDIT MODAL ================= */}
      {editingFee && (
        <div className="modal">
          <div className="modal-box">
            <h3>Edit Fee Amount</h3>
            <input
              type="number"
              value={newAmount}
              onChange={(e) => setNewAmount(e.target.value)}
            />
            <div className="modal-actions">
              <button onClick={saveEdit}>Save</button>
              <button onClick={() => setEditingFee(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
